export class AraIcon {
	label: string;
	path: string;
	origin: string;

	constructor(label: string, path: string, origin: string = 'material') {
		this.label = label;
		this.path = path;
		this.origin = origin;
	}
}
